import type { BillProtectionFeatureConfig } from '../../../types/insurances/BillProtectionFeatureConfig';

export const billProtection: BillProtectionFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
